import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {NavLink, useParams} from "react-router-dom";
import {Breadcrumb, BreadcrumbHome, BreadcrumbItem, Button, Modal, Text} from "@wfp/ui";
import {iconEditGlyph} from "@wfp/icons";
import {SchoolError, validateSchool} from "../../models/validate-school";
import {School} from "../../models/types";
import {saveSchool} from "../../restapi/school";
import {useRetrieveSchool} from "../../hooks/school";
import {LoadingCenter} from "../commons/loading-center";
import {SchoolCard} from "./card";
import {SchoolForm} from "./form";

export const SchoolDetail = () => {
    const {i18n, t} = useTranslation();
    const {id} = useParams();
    const [error, setError] = useState<SchoolError>();
    const [school, setSchool] = useState<School>();
    const [schoolEdit, setSchoolEdit] = useState<School>();

    const data = useRetrieveSchool({id: Number(id), onError: (e) => setError(e as SchoolError)});

    useEffect(() => {
        if(data) {
            setSchool(data);
        }
    }, [data]);

    function handleEditSubmit() {
        if (!!schoolEdit) {
            setError(undefined);
            validateSchool(schoolEdit)
                .then((data) => saveSchool(data)
                    .then((res) => {
                        setSchool(res);
                        setError(undefined);
                        setSchoolEdit(undefined);
                    })
                    .catch(error => setError(error)))
                .catch(error => setError(error));
        }
    }

    function handleEditClose() {
        setSchoolEdit(undefined);
        setError(undefined);
    }

    return (
        <div className="m-10">
            <Breadcrumb className='mb-5'>
                <BreadcrumbItem>
                    <NavLink to="/"><BreadcrumbHome/></NavLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <NavLink to="/schools">{t('school')}</NavLink>
                </BreadcrumbItem>
                <BreadcrumbItem disableLink>
                    {t('view_school')}
                </BreadcrumbItem>
            </Breadcrumb>
            <div className="flex mt-10 mb-5 mx-0">
                <Text kind='h1'>{t("school_details")}</Text>
                <div className={`${i18n.dir() === 'ltr' ? 'ml-auto' : 'mr-auto'}`}>
                    <div className="grid-flow-row flex auto-rows-max mb-10 text-end">
                        <div className="mx-3">
                            <Button onClickCapture={() => setSchoolEdit({...school} as School)} className='!inline-flex' icon={iconEditGlyph} iconReverse>
                                {t('edit_school')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        {!!school && (
            <div className="flex items-start max-w-md py-4 px-8 bg-white shadow-md rounded-lg my-10 mx-5">
                <SchoolCard item={school} />
            </div>
        )}
        {!!schoolEdit && (
            <Modal
                open={true}
                modalHeading={t('edit_school') || ''}
                modalLabel={t('edit_school') || ''}
                primaryButtonText={t('save') || ''}
                onRequestSubmit={handleEditSubmit}
                onRequestClose={handleEditClose}
                secondaryButtonText={t('cancel') || ''}
                onSecondarySubmit={handleEditClose}
            >
                <SchoolForm school={schoolEdit} error={error} onChange={setSchoolEdit}/>
            </Modal>
        )}
        {!(error || school) && (
            <LoadingCenter/>
        )}
        </div>
    )
}
